import React from 'react';
import { InsightSection } from 'store/state/insightsContext';
import { InsightType } from 'utils/entities';
import { useLocale } from 'locale';
import CarouselStories from 'components/view-pager-to-stories';
import { useTheme } from 'hooks/useTheme';
import WidgetWrapper from 'components/widget/common/widget-wrapper';
import { NuisancesWidgetProps } from '../index';
import WidgetCollapsedWrapper from 'components/widget/common/widget-collapsed-wrapper';

const NuisancesWidget: React.FunctionComponent<NuisancesWidgetProps> = React.memo(({
  carouselData,
  setActiveInsightId,
  setActiveCarouselIdx,
  carouselIdx,
  isCollapsed,
  showCarousel,
}) => {

  const { t } = useLocale();
  const { colors } = useTheme();

  if (!carouselData || !carouselData.length || !showCarousel) return null;

  const carousel = (
    <CarouselStories
      onSlideIndexChange={(idx) => setActiveCarouselIdx(idx)}
      slideIndex={carouselIdx}
      color={colors.insights.nuisances}
      insights={carouselData}
      onReadMoreClick={setActiveInsightId}
    />
  );

  const wrapperProps = {
    carousel,
    targetId: InsightSection.Nuisances,
    styleType: InsightType.Nuisances,
    title: t('widgetTitle.nuisances'),
  };

  return isCollapsed
    ? <WidgetCollapsedWrapper {...wrapperProps} />
    : <WidgetWrapper {...wrapperProps} />;

});

export default NuisancesWidget;
